/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
    title: '',
};

const PageHeaderTopInfoTitle = (props) => {
    const classNames = [
        'c-type-title--3',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

PageHeaderTopInfoTitle.propTypes = propTypes;

PageHeaderTopInfoTitle.defaultProps = defaultProps;

export default PageHeaderTopInfoTitle;
